import React from 'react';

interface PresenceDotProps {
  online: boolean;
  className?: string;
}

export default function PresenceDot({ online, className = '' }: PresenceDotProps) {
  return (
    <span
      aria-label={online ? 'online' : 'offline'}
      title={online ? 'online' : 'offline'}
      className={`inline-block w-2 h-2 rounded-full ${online ? 'bg-emerald-400' : 'bg-neutral-600'} ${className}`}
    />
  );
}